import $ from 'jquery';
import enquire from 'enquire.js';

$(() => {
  const productAside = $('.product-side-panel');
  const shoppingBasketAside = $('.shopping-basket .shopping-basket-side-panel');
  const mobileMenuHeader = $('.mobile .main-head');

  enquire.register('screen and (min-width:1024px)', {
    match: () => {
      productAside.stick_in_parent({
        recalc_every: 1,
        sticky_class: 'is-stuck',
      })
      .on('sticky_kit:bottom', () => {
        productAside.removeClass('is-stuck');
      });

      shoppingBasketAside.stick_in_parent({
        recalc_every: 1,
        sticky_class: 'is-stuck',
      })
      .on('sticky_kit:bottom', () => {
        shoppingBasketAside.removeClass('is-stuck');
      });
    },
    unmatch: () => {
      productAside.trigger('sticky_kit:detach');
      shoppingBasketAside.trigger('sticky_kit:detach');
    },
  });
  enquire.register('screen and (max-width:1024px)', {
    match: () => {
      if (!$('.cookies-panel').hasClass('hiden')) {
        mobileMenuHeader.stick_in_parent({
          sticky_class: 'is-stuck',
        });
      } else {
        mobileMenuHeader.trigger('sticky_kit:detach');
        mobileMenuHeader.addClass('sticky');
      }
    },
    unmatch: () => {
      mobileMenuHeader.trigger('sticky_kit:detach');
      mobileMenuHeader.removeClass('sticky');
    },
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/sticky.js
 **/